import { render, staticRenderFns } from "./CustomMoreList.vue?vue&type=template&id=b191b500&scoped=true&"
import script from "./CustomMoreList.vue?vue&type=script&lang=js&"
export * from "./CustomMoreList.vue?vue&type=script&lang=js&"
import style0 from "./CustomMoreList.vue?vue&type=style&index=0&id=b191b500&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b191b500",
  null
  
)

export default component.exports